import React from 'react';

import WithGradientLayout from '../../layouts/with_gradient_layout/with_gradient_layout';

import classes from './legal_mentions_header.module.css';

const LegalMentionsHeader = () => <WithGradientLayout className={classes.container} />;

export default LegalMentionsHeader;
